<template>
	<button
		type="button"
		class="p-1 shrink-0 inline-flex"
		:class="{ active: isActive, 'bg-indigo-200 rounded-md': isActive }"
		@click="onClick"
		:title="$t('Numbered list')"
		tabindex="-1"
	>
		<NumberedListIcon class="w-5 h-5" />
	</button>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { Editor } from "@tiptap/vue-3";
import { NumberedListIcon } from "@heroicons/vue/24/outline";

export default defineComponent({
	name: "NumberedListButton",
	components: { NumberedListIcon },
	props: {
		editor: { type: Object as PropType<Editor | null | undefined>, required: true },
	},
	computed: {
		isActive(): boolean {
			return !!(this.editor as any)?.isActive?.("orderedList");
		},
	},
	methods: {
		onClick() {
			(this.editor as any)?.chain?.().focus().toggleOrderedList().run();
		},
	},
});
</script>
